export default __webpack_public_path__ + "static/media/Link_Expire.5e98f9f8.svg";